import { useEffect, useState } from "react";
import * as d3 from "d3";

function Session (props) {
    const data = props.data.filter(el => el.test),
        colors = props.colors,
        getLabel = props.getLabel,
        prompt = props.prompt,
        setPrompt = props.setPrompt;

    const tab = {
        prompt: '15em',
        matches: '26em',
        report: '6em'
    }

    function parseData (data) {
        const prompts = [...new Set(data.map(el => el.test.map(item => item.prompt)).flat())] 
        const flattened = data.map(el => el.test).flat()
        const parsed = prompts.map(prompt => {
            const answers = flattened.filter(item => item.prompt === prompt)
            var matchRight = 0, matchClose = 0, matchWrong = 0;
            var reportQuality = 0, reportProblem = 0;

            answers.forEach(answer => {
                if (['queer', 'nonbinary'].includes(prompt)) {
                    if (['gen20', 'gen02'].includes(answer.answer)) matchWrong += 1
                    else matchRight += 1
                } else {
                    if (answer.answer === prompt) matchRight += 1
                    else {
                        const aF = +answer.answer[4],
                            aM = +answer.answer[3],
                            pF = +prompt[4],
                            pM = +prompt[3];
                        
                        if (Math.abs(aF - pF) + Math.abs(aM - pM) < 2) matchClose += 1
                        else matchWrong += 1
                    }
                }
                if (answer.report_problem) reportProblem += 1
                if (answer.report_quality) reportQuality += 1
            })
            return {
                prompt: prompt,
                answers: answers,
                match_right: matchRight,
                match_close: matchClose,
                match_wrong: matchWrong,
                report_problem: reportProblem,
                report_quality: reportQuality
            }
        })
        return parsed
    }

    function drawTable (data) {
        if (data.length === 0) {
            d3.select('#session_rows')
            .selectAll('.table_row')
            .remove()
        } else {
    
            const sorted = data.sort((a, b) => d3.descending(a.match_right / a.answers.length, b.match_right / b.answers.length));

            function updatePrompt(newPrompt){
                if (newPrompt === prompt) setPrompt()
                else setPrompt(newPrompt)
            }
            
            d3.select('#session_rows')
                .selectAll('.table_row')
                .data(sorted)
                .join(
                    function(enter) {
                        const row = enter.append('div')
                            .attr('class', 'table_row')
                            .style('background-color', (d,i) => i%2===0 ? 'rgb(255,255,255,0.07)' : 'rgb(255,255,255,0.035)')
                            .style('cursor', 'pointer')
                            .on('click', (e,d) => updatePrompt(d.prompt))
    
                        row.append('div')
                            .attr('class', 'prompt')
                            .style('width', tab.prompt)
                            .html(d => getLabel(d.prompt))
    
                        const match = row.append('div')
                            .attr('class', 'matches')
                            .style('width', tab.matches)
    
                        match.append('div')
                            .attr('class', 'count_rect match_right')
                            .style('display', d => d.match_right === 0 ? 'none' : undefined)
                            .style('width', d => d.match_right / d.answers.length * 26 + 'em')
                            .style('background-color', d => ['queer', 'nonbinary'].includes(d.prompt) ? colors.umbrella : colors.right)
                            .html(d => Math.round(100 * d.match_right / d.answers.length)+'%')
    
                        match.append('div')
                            .attr('class', 'count_rect match_close')
                            .style('display', d => d.match_close === 0 ? 'none' : undefined)
                            .style('width', d => d.match_close / d.answers.length * 26 + 'em')
                            .style('background-color', colors.close)
                            .html(d => Math.round(100 * d.match_close / d.answers.length)+'%')
    
                        match.append('div')
                            .attr('class', 'count_rect match_wrong')
                            .style('display', d => d.match_wrong === 0 ? 'none' : undefined)
                            .style('width', d => d.match_wrong / d.answers.length * 26 + 'em')
                            .style('background-color', colors.wrong)
                            .html(d => Math.round(100 * d.match_wrong / d.answers.length)+'%')
    
                        row.append('div')
                            .attr('class', 'report_quality')
                            .style('width', tab.report)
                            .html(d => d.report_quality);

                        row.append('div')
                            .attr('class', 'report_problem')
                            .style('width', tab.report)
                            .html(d => d.report_problem);
                    },
                    function (update) {
                        update.on('click', (e,d) => updatePrompt(d.prompt))

                        update.select('.prompt')
                            .html(d => getLabel(d.prompt));
    
                        update.select('.match_right')
                            .style('background-color', d => ['queer', 'nonbinary'].includes(d.prompt) ? colors.umbrella : colors.right)
                            .style('width', d => d.match_right / d.answers.length * 26 + 'em')
                            .html(d => Math.round(100 * d.match_right / d.answers.length)+'%')
    
                        update.select('.match_close')
                            .style('width', d => d.match_close / d.answers.length * 26 + 'em')
                            .html(d => Math.round(100 * d.match_close / d.answers.length)+'%')
    
                        update.select('.match_wrong')
                            .style('width', d => d.match_wrong / d.answers.length * 26 + 'em')
                            .html(d => Math.round(100 * d.match_wrong / d.answers.length)+'%')

                        update.select('.report_problem')
                            .html(d => d.report_problem);
    
                        update.select('.report_quality')
                            .html(d => d.report_quality);
                    }
                )
        }
    }

    const parsed = parseData(data)

    useEffect(() => {

        drawTable(parsed)
    }, [data]);

  return (
    <div className="panel" style={{maxWidth: '95%', marginBottom: '0.25em', paddingBottom: '0.5em'}}>
        <h2 style={{margin: '0.5em'}}>Session results</h2>
        <div className="table_row head_row">
            <div className="table_head" style={{width: tab.prompt}}>Prompt</div>
            <div className="table_head" style={{width: tab.matches}}>Matches</div>
            <div className="table_head" style={{width: tab.report}}>Low quality</div>
            <div className="table_head" style={{width: tab.report}}>Offensive</div>
        </div>
        <div id="session_rows"  className="table_rows"></div>
    </div>
  );
}

export default Session;
